module.exports = __webpack_public_path__ + "static/media/Search results.59a3dfd0.svg";